import React, { useState, useEffect } from "react";
// Mevcut import satırlarınıza şunları ekleyin/güncelleyin:
import { FileText, TrendingDown, TrendingUp, Users, Scale, ChevronLeft, HandCoins } from "lucide-react";
import CreditorsReport from "./CreditorsReport";
import Balance from "./Balance"; 
import ExpenseReport from "./ExpenseReport";
import IncomeReport from "./IncomeReport";
import DebtorsReport from "./DebtorsReport";
import Balances from "./Balances";
// YENİ: initialReport prop'u eklendi
export default function Reports({ initialReport = "menu" }) {
  const [activeReport, setActiveReport] = useState(initialReport);
  const [selectedHesapKodu, setSelectedHesapKodu] = useState(null); // Bakiye sayfasına iletilecek kod

  // Borçlular listesinden "Ayrıntı" butonuna basılınca çalışacak fonksiyon
  const handleGoToBalance = (hesapKodu) => {
    setSelectedHesapKodu(hesapKodu);
    setActiveReport("bakiye"); 
  };   
  // Sol menüden tekrar Raporlar'a tıklanırsa ana menüye dönmesini sağlar
  useEffect(() => {
    setActiveReport(initialReport);
  }, [initialReport]);

 
  // 1. Daire/Villa Bakiye Raporu
  if (activeReport === "bakiye") {
    return (
      <div className="report-container">
        <button onClick={() => { setActiveReport("menu"); setSelectedHesapKodu(null); }} className="no-print" style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "8px", background: "none", border: "none", color: "#3b82f6", cursor: "pointer", fontWeight: "bold" }}>
          <ChevronLeft size={20} /> Raporlar Menüsüne Dön
        </button>
        {/* Seçili hesap kodunu Balance bileşenine 'initialKodu' olarak iletiyoruz */}
        <Balance initialKodu={selectedHesapKodu} /> 
      </div>
    );
  }

  // 2. Gider Raporu
  if (activeReport === "gider") {
    return (
      <div className="report-container">
        <button onClick={() => setActiveReport("menu")} style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "8px", background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontWeight: "bold" }}>
          <ChevronLeft size={20} /> Raporlar Menüsüne Dön
        </button>
        <ExpenseReport />
      </div>
    );
  }

  // 3. Gelir Raporu
  if (activeReport === "gelir") {
    return (
      <div className="report-container">
        <button onClick={() => setActiveReport("menu")} style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "8px", background: "none", border: "none", color: "#10b981", cursor: "pointer", fontWeight: "bold" }}>
          <ChevronLeft size={20} /> Raporlar Menüsüne Dön
        </button>
        <IncomeReport />
      </div>
    );
  }

  // 4. Borçlular Listesi
  if (activeReport === "borclular") {
    return (
      <div className="report-container">
        <button onClick={() => setActiveReport("menu")} className="no-print" style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "8px", background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontWeight: "bold" }}>
          <ChevronLeft size={20} /> Raporlar Menüsüne Dön
        </button>
        <DebtorsReport onDetailClick={handleGoToBalance} />
      </div>
    );
  }
  // 4.5. Alacaklılar Listesi (YENİ EKLENDİ)
  if (activeReport === "alacaklilar") {
    return (
      <div className="report-container">
        <button onClick={() => setActiveReport("menu")} className="no-print" style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "8px", background: "none", border: "none", color: "#10b981", cursor: "pointer", fontWeight: "bold" }}>
          <ChevronLeft size={20} /> Raporlar Menüsüne Dön
        </button>
        <CreditorsReport onDetailClick={handleGoToBalance} />
      </div>
    );
  }
  // 5. Bilanço Raporu
  if (activeReport === "bilanco") {
    return (
      <div style={{ animation: "fadeIn 0.4s ease-out" }}>
        <button 
          onClick={() => setActiveReport("menu")} 
          style={{ 
            marginBottom: "20px", 
            padding: "10px 16px", 
            background: "white", 
            border: "1px solid #cbd5e1", 
            borderRadius: "8px", 
            cursor: "pointer", 
            display: "inline-flex", 
            alignItems: "center", 
            gap: "8px", 
            color: "#475569", 
            fontWeight: "bold",
            boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
          }}
        >
          ← Raporlar Menüsüne Dön
        </button>
        
        {/* Ayrı dosya olarak hazırladığımız Excel özellikli Bilanço burada yükleniyor */}
        <Balances />
      </div>
    );
  }

  // ANA MENÜ (5 BUTON)
  return (
    <div className="reports-menu-page" style={{ padding: "20px", maxWidth: "900px", margin: "0 auto" }}>
      <h2 style={{ color: "#1e293b", marginBottom: "24px" }}>Raporlar ve Analizler</h2>
      
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
        
        <button onClick={() => setActiveReport("bakiye")} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "30px 20px", background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", cursor: "pointer", transition: "all 0.2s" }}>
          <div style={{ background: "#eff6ff", padding: "16px", borderRadius: "50%" }}><FileText size={32} color="#3b82f6" /></div>
          <h3 style={{ margin: 0, fontSize: "16px", color: "#1e293b" }}>1. Daire / Villa Bakiye Raporu</h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Tüm işlemler ve hesap dökümleri</p>
        </button>

        <button onClick={() => setActiveReport("gider")} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "30px 20px", background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", cursor: "pointer", transition: "all 0.2s" }}>
          <div style={{ background: "#fef2f2", padding: "16px", borderRadius: "50%" }}><TrendingDown size={32} color="#ef4444" /></div>
          <h3 style={{ margin: 0, fontSize: "16px", color: "#1e293b" }}>2. Gider Raporu</h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Aylık ve kalem bazlı gider grafikleri</p>
        </button>

        <button onClick={() => setActiveReport("gelir")} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "30px 20px", background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", cursor: "pointer", transition: "all 0.2s" }}>
          <div style={{ background: "#ecfdf5", padding: "16px", borderRadius: "50%" }}><TrendingUp size={32} color="#10b981" /></div>
          <h3 style={{ margin: 0, fontSize: "16px", color: "#1e293b" }}>3. Gelir Raporu</h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Aylık gelir dağılımı grafikleri</p>
        </button>

        <button onClick={() => setActiveReport("borclular")} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "30px 20px", background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", cursor: "pointer", transition: "all 0.2s" }}>
          <div style={{ background: "#fffbeb", padding: "16px", borderRadius: "50%" }}><Users size={32} color="#f59e0b" /></div>
          <h3 style={{ margin: 0, fontSize: "16px", color: "#1e293b" }}>4. Borçlular Listesi</h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Geciken ödemeler ve PDF çıktısı</p>
        </button>
        <button onClick={() => setActiveReport("alacaklilar")} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "30px 20px", background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", cursor: "pointer", transition: "all 0.2s" }}>
          <div style={{ background: "#ecfdf5", padding: "16px", borderRadius: "50%" }}><HandCoins size={32} color="#10b981" /></div>
          <h3 style={{ margin: 0, fontSize: "16px", color: "#1e293b" }}>5. Alacaklılar Listesi</h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Fazla ödeme yapanlar ve avanslar</p>
        </button>
        <button onClick={() => setActiveReport("bilanco")} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "30px 20px", background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", cursor: "pointer", transition: "all 0.2s" }}>
          <div style={{ background: "#f3e8ff", padding: "16px", borderRadius: "50%" }}><Scale size={32} color="#a855f7" /></div>
          <h3 style={{ margin: 0, fontSize: "16px", color: "#1e293b" }}>6. Bilanço</h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Gelir ve Gider karşılıklı analizi</p>
        </button>
        {/* ... önceki 5 buton ... */}

        
      </div>
    </div>
  );
}